import React from "react";
import { Link } from "react-scroll";
import VijayProfile from "../assets/vijay-profile.jpe";

const Home = () => (
  <section name="Home" className="relative overflow-hidden">
    <div className="absolute inset-0 grid-bg opacity-70" />
    <div className="hero-shell relative z-10">
      <div className="space-y-7 reveal-up">
        <span className="pill">Full-stack developer · Coimbatore, IN</span>
        <div>
          <p className="mb-3 font-mono text-xs uppercase tracking-[.25em] text-[#e65335]">Hello, I’m Vijay</p>
          <h1 className="max-w-3xl text-6xl font-bold leading-[.95] tracking-[-.06em] sm:text-8xl">I make the web<br /><em className="text-[#e65335]">feel human.</em></h1>
        </div>
        <p className="max-w-xl text-lg leading-8 text-[#65706a]">Full Stack Developer crafting sharp interfaces, useful motion, and dependable digital products with React, Next.js, Node.js, and Tailwind CSS.</p>
        <div className="flex flex-wrap gap-3"><Link to="Projects" smooth duration={500} offset={-90} className="primary-button cursor-pointer">See selected work ↗</Link><a href="/Vijay_SoftwareDeveloper.pdf" download="Vijay-A-Resume.pdf" className="secondary-button">Download CV ↓</a></div>
        <div className="flex gap-8 border-t border-[#d7d1c5] pt-5 font-mono text-xs uppercase tracking-[.16em] text-[#65706a]"><span><strong className="block text-2xl text-[#17201c]">06</strong>projects shipped</span><span><strong className="block text-2xl text-[#17201c]">02</strong>years learning</span></div>
      </div>
      <div className="relative flex items-center justify-center reveal-up reveal-delay-2">
        <div className="absolute h-72 w-72 rounded-full bg-[#c9d84a]/50 blur-3xl" />
        <div className="relative rotate-2 rounded-[2rem] border border-[#17201c] bg-[#e8e2d6] p-4 shadow-[12px_12px_0_#17201c] transition hover:rotate-0">
          <img src={VijayProfile} alt="Vijay" className="relative aspect-[4/5] w-full max-w-[28rem] rounded-[1.5rem] object-cover object-top float-fast" />
          <span className="absolute -bottom-5 -left-5 rounded-full bg-[#e65335] px-5 py-3 font-mono text-xs font-bold uppercase tracking-widest text-white">Available ↗</span>
          <span className="absolute -right-4 -top-4 rounded-full bg-[#17201c] px-4 py-3 font-mono text-xs text-[#c9d84a]">01 / 01</span>
        </div>
      </div>
    </div>
  </section>
);

export default Home;
